import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../store";
import { CountState, DashboardFilterState } from "../types/index";
import {
  dashboardFiltersPartiallyEqual,
  format,
  isFeatureEnabled,
  numberFormat,
} from "../utilities";
import ProgressOverlay from "./ProgressOverlay";

function mapStateToProps({ count, dashboardFilter }: StoreState) {
  return {
    count,
    dashboardFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchCount: (dashboardFilter: DashboardFilterState) =>
      dispatch.count.fetchCount(dashboardFilter),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class CountChart extends React.Component<Props & StyledComponentProps> {
  public componentDidMount() {
    if (!this.props.count.customerCount) {
      this.props.fetchCount(this.props.dashboardFilter);
    }
  }

  public componentDidUpdate(previousProps: Props) {
    if (
      !dashboardFiltersPartiallyEqual(
        previousProps.dashboardFilter,
        this.props.dashboardFilter,
        ["dateRange", "score"]
      )
    ) {
      this.props.fetchCount(this.props.dashboardFilter);
    }
  }

  public render() {
    const { classes } = this.props;
    const dateLabel = format(new Date(), "MMMM yyyy");
    const churnCount = this.formatChurnCount(this.props.count);

    return (
      <Paper className={classes && classes.paper}>
        <ProgressOverlay loading={this.props.count.loading}>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <Typography variant="h6">Statistiken für {dateLabel}</Typography>
            </Grid>
          </Grid>
          <Grid
            style={{ height: "calc(100% - 48px)" }}
            container={true}
            spacing={2}
            direction="column"
            justify="center"
            alignItems="stretch"
          >
            <Grid item={true}>
              <Grid container={true}>
                <Grid item={true} xs={12}>
                  <Typography variant="h4" align="center">
                    # {numberFormat(this.props.count.customerCount, false)}{" "}
                    Kunden
                  </Typography>
                </Grid>
                <Grid item={true} xs={12}>
                  <Typography variant="h4" align="center">
                    #{" "}
                    {numberFormat(
                      this.props.count.contractElectricityCount,
                      false
                    )}{" "}
                    Verträge Strom
                  </Typography>
                </Grid>
                <Grid item={true} xs={12}>
                  <Typography variant="h4" align="center">
                    # {numberFormat(this.props.count.contractGasCount, false)}{" "}
                    Verträge Gas
                  </Typography>
                </Grid>
                <Grid item={true} xs={12}>
                  <Typography variant="h4" align="center">
                    #{" "}
                    {numberFormat(this.props.count.contractHeatingCount, false)}{" "}
                    Verträge Fernwärme
                  </Typography>
                </Grid>
                {isFeatureEnabled(process.env.REACT_APP_FEATURE_GLASS_FIBER) ? (
                  <Grid item={true} xs={12}>
                    <Typography variant="h4" align="center">
                      #{" "}
                      {numberFormat(
                        this.props.count.contractGlassFiberCount,
                        false
                      )}{" "}
                      Verträge Glasfaser
                    </Typography>
                  </Grid>
                ) : (
                  <></>
                )}
                <Grid item={true} xs={12}>
                  <Typography variant="h4" align="center">
                    {churnCount}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ProgressOverlay>
      </Paper>
    );
  }

  private formatChurnCount(count: CountState) {
    let churnCount: string;
    if (count.churnCountBeginTimestamp && count.churnCountEndTimestamp) {
      const formatDay = "d.";
      const formatDayMonth = "d. MMM.";
      const formatDayMonthYear = "d. MMM. yyyy";
      const sameYear =
        count.churnCountBeginTimestamp.getFullYear() ===
        count.churnCountEndTimestamp.getFullYear();
      const sameYearAndMonth =
        sameYear &&
        count.churnCountBeginTimestamp.getMonth() ===
          count.churnCountEndTimestamp.getMonth();
      const beginDate = format(
        count.churnCountBeginTimestamp,
        sameYearAndMonth
          ? formatDay
          : sameYear
          ? formatDayMonth
          : formatDayMonthYear
      );
      const endDate = format(count.churnCountEndTimestamp, formatDayMonthYear);
      churnCount = `# ${numberFormat(
        count.churnCount,
        false
      )} Kündiger (${beginDate} – ${endDate})`;
    } else {
      churnCount = "# Kündiger liegt noch nicht vor";
    }
    return churnCount;
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  paper: {
    height: "100%",
    padding: theme.spacing(2),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CountChart));



// WEBPACK FOOTER //
// ./src/components/CountChart.tsx